export enum GalleryJustify {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Evenly = 'evenly',
}

export const GALLERY_WIDGET_ELEMENT_NAME = 'pimster-gallery-widget';
export const PATH_CONFIG_KEY = 'options';
export const GALLERY_DEFAULT_JUSTIFY = GalleryJustify.Left;
